import { Icon } from '@evisort/eds/components/Icon/Icon';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  pin: {
    id: 'AppSidebarNav.pinItem',
    defaultMessage: 'Pin {label}',
    description:
      'Accessible label for the button that pins a sidebar nav entry.',
  },
  unpin: {
    id: 'AppSidebarNav.unpinItem',
    defaultMessage: 'Unpin {label}',
    description:
      'Accessible label for the button that unpins a sidebar nav entry.',
  },
});

interface SidebarPinButtonProps {
  isPinned: boolean;
  label: string;
  onToggle: () => void;
}

export function SidebarPinButton({
  isPinned,
  label,
  onToggle,
}: SidebarPinButtonProps) {
  const intl = useIntl();
  const actionLabel = intl.formatMessage(
    isPinned ? messages.unpin : messages.pin,
    { label },
  );

  return (
    <button
      type="button"
      aria-label={actionLabel}
      aria-pressed={isPinned}
      className={`sidebar-pin-btn${isPinned ? ' sidebar-pin-btn--pinned' : ''}`}
      data-amp-track-action={isPinned ? 'unpin-nav-item' : 'pin-nav-item'}
      title={actionLabel}
      onClick={(event) => {
        // The pin sits inside a row that is itself a link or a drag source.
        event.stopPropagation();
        onToggle();
      }}
    >
      <Icon filled={isPinned} icon="pin" size="s" />
    </button>
  );
}
